import { useActiveConversation } from '../components/chat/ActiveConversationContext';
import { useChatOverlayOpen } from './use-chat-overlay';
import { useSitePaneFits } from './use-site-pane';
import { useBlogReviewFlow, type BlogReviewFlow } from './blog-review-store';

export function useBlogReviewPane(): BlogReviewFlow | null {
  const flow = useBlogReviewFlow();
  const chatOpen = useChatOverlayOpen();
  const fits = useSitePaneFits();
  const { activeConversationId } = useActiveConversation();
  if (!flow?.beside || !chatOpen || !fits) return null;
  if (flow.conversationId !== activeConversationId) return null;
  return flow;
}
